import React from 'react';

const AuthBypassBanner = () => (
  <div className="auth-bypass-banner" role="status" aria-live="polite">
    Authentication is currently bypassed. Do not use with real data.
  </div>
);

export default AuthBypassBanner;

